import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	menuLabel: {
		id: 'project-details.menu-label',
		defaultMessage: 'More options',
		description: 'label for the more icon that triggers the delete options menu',
	},
	actionDeleteProject: {
		id: 'project-details.action-delete-project',
		defaultMessage: 'Delete project',
		description: '',
	},
	actionDeleteServiceProject: {
		id: 'project-details.action-delete-service-project',
		defaultMessage: 'Delete service project',
		description: 'This is a link description in the context menu of the project settings',
	},
	actionTrashProject: {
		id: 'project-details.action-trash-project',
		defaultMessage: 'Move to trash',
		description: 'Action title to move the project to trash',
	},
});
